import { render, staticRenderFns } from "./OrderConfirmationButtons.vue?vue&type=template&id=7696acc5&lang=pug"
import script from "./OrderConfirmationButtons.vue?vue&type=script&lang=js"
export * from "./OrderConfirmationButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports